export default __webpack_public_path__ + "static/media/optum.7ae8de47.svg";